/**
 * Removes Word-specific elements and attributes from HTML
 */
export class WordElementCleaner {
  clean(container) {
    // Remove Word conditional comments and XML elements
    const wordElements = container.querySelectorAll('o\\:p, w\\:*, v\\:*');
    wordElements.forEach((el) => el.remove());

    // Remove elements with Word-specific classes
    const wordClassElements = container.querySelectorAll(
      '[class*="Mso"], [class*="mso"]',
    );
    wordClassElements.forEach((el) => {
      el.className = el.className.replace(/\b[Mm]so\w*\b/g, '').trim();
      if (!el.className) {
        el.removeAttribute('class');
      }
    });

    // Clean Word-specific styles
    const styledElements = container.querySelectorAll('[style]');
    styledElements.forEach((el) => {
      const style = el.getAttribute('style');
      if (style) {
        const cleanedStyle = style
          .replace(/mso-[^;:]*:[^;]*(;|$)/gi, '')
          .replace(/font-family:[^;]*"Times New Roman"[^;]*(;|$)/gi, '')
          .replace(/;\s*;/g, ';')
          .replace(/^;|;$/g, '')
          .trim();

        if (cleanedStyle) {
          el.setAttribute('style', cleanedStyle);
        } else {
          el.removeAttribute('style');
        }
      }
    });
  }
}

/**
 * Removes empty paragraphs and paragraphs with only whitespace/formatting
 */
export class ParagraphCleaner {
  clean(container) {
    const paragraphs = container.querySelectorAll('p');

    paragraphs.forEach((p) => {
      const textContent = p.textContent || '';
      const innerHTML = p.innerHTML || '';

      const isEmptyParagraph =
        textContent.trim() === '' ||
        textContent.replace(/\s/g, '').replace(/\u00A0/g, '') === '' ||
        innerHTML
          .replace(/&nbsp;/g, '')
          .replace(/\s/g, '')
          .replace(/<\/?span[^>]*>/g, '') === '' ||
        innerHTML
          .replace(/&nbsp;/g, '')
          .replace(/\s/g, '')
          .replace(/<\/?[^>]*>/g, '') === '';

      if (isEmptyParagraph) {
        p.remove();
      }
    });
  }
}

/**
 * Cleans excessive whitespace and unnecessary formatting
 */
export class WhitespaceCleaner {
  clean(container) {
    // Remove empty spans and divs
    const emptyElements = container.querySelectorAll('span:empty, div:empty');
    emptyElements.forEach((el) => el.remove());

    // Clean up spans that only contain whitespace
    const spans = container.querySelectorAll('span');
    spans.forEach((span) => {
      const text = span.textContent || '';
      if (text.trim() === '' || text.replace(/\u00A0/g, '').trim() === '') {
        span.remove();
      }
    });

    // Normalize whitespace in text nodes
    const walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT,
      null,
      false,
    );

    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) {
      textNodes.push(node);
    }

    textNodes.forEach((textNode) => {
      textNode.textContent = textNode.textContent.replace(/\s+/g, ' ');
    });
  }
}
